const SIGN_IN_DEEP_LINK = 'mrt://signin';

export default function getSigninDeepLink() {
  const redirectQuery =
    typeof window === 'undefined' ? '' : `?return_to=${encodeURIComponent(window.location.href)}`;

  return `${SIGN_IN_DEEP_LINK}${redirectQuery}`;
}
